import { Avatar } from '@/components/ui/avatar';
import { PressableCard } from '@/components/ui/card';
import { ThemedText } from '@/components/themed-text';
import { Client } from '@/types/client';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';

interface ClientCardProps {
  client: Client;
  onPress?: () => void;
}

export function ClientCard({ client, onPress }: ClientCardProps) {
  const username = client.user.username || 'Unknown';
  const initials = username
    .split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();

  const enrollmentsCount = client.enrollments?.length || 0;

  return (
    <PressableCard onPress={onPress} className="flex-row items-center gap-3 p-4">
      <Avatar src={client.user.image} fallback={initials} />

      <View className="flex-1 gap-0.5">
        <ThemedText className="font-semibold text-base" numberOfLines={1}>
          {username}
        </ThemedText>
        <ThemedText className="text-sm text-neutral-500" numberOfLines={1}>
          {client.user.email}
        </ThemedText>
        {client.phone && (
          <ThemedText className="text-xs text-neutral-400" numberOfLines={1}>
            {client.phone}
          </ThemedText>
        )}
      </View>

      {enrollmentsCount > 0 && (
        <View className="rounded-full bg-primary-50 px-2.5 py-1">
          <ThemedText className="text-xs font-semibold text-primary-700">
            {enrollmentsCount} {enrollmentsCount === 1 ? 'contrato' : 'contratos'}
          </ThemedText>
        </View>
      )}
      <Ionicons className="text-neutral-300" name="chevron-forward" size={16} />
    </PressableCard>
  );
}
